var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _circle, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 216,
    viewBox: "0 0 216 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 216,
    height: 216,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.96 49.6801H39.3999C35.5339 49.6801 32.3999 52.8141 32.3999 56.6801V162.48C32.3999 165.794 35.0862 168.48 38.3999 168.48H168.96C172.274 168.48 174.96 165.794 174.96 162.48V56.6801C174.96 52.8141 171.826 49.6801 167.96 49.6801Z",
    stroke: "#65558F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3999 58.84C32.3999 54.974 35.5339 51.84 39.3999 51.84H167.96C171.826 51.84 174.96 54.974 174.96 58.84V75.6H32.3999V58.84Z",
    fill: "#65558F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6401 43.2C62.6401 40.8141 64.5743 38.88 66.9601 38.88C69.346 38.88 71.2801 40.8141 71.2801 43.2V56.16C71.2801 58.5459 69.346 60.48 66.9601 60.48C64.5743 60.48 62.6401 58.5459 62.6401 56.16V43.2Z",
    fill: "#65558F",
    stroke: "#65558F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9199 94.88C52.9199 93.7754 53.8154 92.88 54.9199 92.88H66.0399C67.1445 92.88 68.0399 93.7754 68.0399 94.88V106C68.0399 107.105 67.1445 108 66.0399 108H54.9199C53.8154 108 52.9199 107.105 52.9199 106V94.88Z",
    stroke: "#65558F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.24 94.88C111.24 93.7754 112.136 92.88 113.24 92.88H124.36C125.465 92.88 126.36 93.7754 126.36 94.88V106C126.36 107.105 125.465 108 124.36 108H113.24C112.136 108 111.24 107.105 111.24 106V94.88Z",
    stroke: "#65558F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M139.32 94.88C139.32 93.7754 140.215 92.88 141.32 92.88H152.44C153.544 92.88 154.44 93.7754 154.44 94.88V106C154.44 107.105 153.544 108 152.44 108H141.32C140.215 108 139.32 107.105 139.32 106V94.88Z",
    stroke: "#65558F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.24 127.28C111.24 126.175 112.136 125.28 113.24 125.28H124.36C125.465 125.28 126.36 126.175 126.36 127.28V138.4C126.36 139.505 125.465 140.4 124.36 140.4H113.24C112.136 140.4 111.24 139.505 111.24 138.4V127.28Z",
    fill: "#65558F",
    stroke: "#65558F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81 94.88C81 93.7754 81.8954 92.88 83 92.88H94.12C95.2246 92.88 96.12 93.7754 96.12 94.88V106C96.12 107.105 95.2246 108 94.12 108H83C81.8954 108 81 107.105 81 106V94.88Z",
    fill: "#65558F",
    stroke: "#65558F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81 127.28C81 126.175 81.8954 125.28 83 125.28H94.12C95.2246 125.28 96.12 126.175 96.12 127.28V138.4C96.12 139.505 95.2246 140.4 94.12 140.4H83C81.8954 140.4 81 139.505 81 138.4V127.28Z",
    stroke: "#65558F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M136.08 43.2C136.08 40.8141 138.014 38.88 140.4 38.88C142.786 38.88 144.72 40.8141 144.72 43.2V56.16C144.72 58.5459 142.786 60.48 140.4 60.48C138.014 60.48 136.08 58.5459 136.08 56.16V43.2Z",
    fill: "#65558F",
    stroke: "#65558F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 172.8,
    cy: 155.52,
    r: 28.08,
    fill: "white",
    stroke: "#65558F",
    strokeWidth: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M169.56 141.48C169.56 139.691 171.011 138.24 172.8 138.24V138.24C174.589 138.24 176.04 139.691 176.04 141.48V154.44C176.04 156.229 174.589 157.68 172.8 157.68V157.68C171.011 157.68 169.56 156.229 169.56 154.44V141.48Z",
    stroke: "#65558F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M169.56 169.56C169.56 171.349 171.011 172.8 172.8 172.8V172.8C174.589 172.8 176.04 171.349 176.04 169.56V169.56C176.04 167.771 174.589 166.32 172.8 166.32V166.32C171.011 166.32 169.56 167.771 169.56 169.56V169.56Z",
    stroke: "#65558F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7183 173.382C23.6683 173.382 25.249 171.801 25.249 169.851V169.851C25.249 167.902 23.6683 166.321 21.7183 166.321L10.0115 166.321C8.06155 166.321 6.48079 167.902 6.48079 169.851V169.851C6.48079 171.801 8.06154 173.382 10.0115 173.382L21.7183 173.382Z",
    stroke: "#65558F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6333 193.31C37.6333 195.26 36.0525 196.841 34.1026 196.841V196.841C32.1526 196.841 30.5719 195.26 30.5719 193.31L30.5719 181.603C30.5719 179.653 32.1526 178.072 34.1026 178.072V178.072C36.0525 178.072 37.6333 179.653 37.6333 181.603L37.6333 193.31Z",
    stroke: "#65558F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDashboard);
export default __webpack_public_path__ + "static/media/empty-dashboard.77231c38379d8afe8037c25f8a2bbcea.svg";
export { ForwardRef as ReactComponent };